import React from 'react';
import { Clock3Icon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { site } from '../../data/site';
import { buttonStyles, focusRing } from '../../utils/styles';
export function ContactOptions() {
  const {
    t
  } = useLanguage();
  return <div data-id="element-326" data-mp="bad4gj1lxjps">
      <p className="font-semibold text-ink-soft" data-id="element-327" data-mp="balhcaxqcp0z">{t({
        en: 'Call us anytime, day or night',
        es: 'Llámanos a cualquier hora, de día o de noche'
      })}</p>
      <a href={site.tel} className={`mt-1 inline-block rounded-lg font-display text-4xl font-bold text-brand-dark hover:text-brand sm:text-5xl ${focusRing}`} data-id="element-328" data-mp="12zgbg6kvp864">
        {site.phoneDisplay}
      </a>

      <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-329" data-mp="u6lgc5p4ksu2">
        <a href={site.tel} className={buttonStyles.primary} data-id="element-330" data-mp="1qq2j3wqz0qfl">
          <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-331" data-mp="1qrnefol40dei" />
          {t({
          en: 'Call Now',
          es: 'Llamar Ahora'
        })}
        </a>
        <a href={site.whatsapp} target="_blank" rel="noopener noreferrer" className={buttonStyles.whatsapp} data-id="element-332" data-mp="guvb58kc7im">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-333" data-mp="5g7f1h450ygz" />
          {t({
          en: 'Text / WhatsApp',
          es: 'Texto / WhatsApp'
        })}
        </a>
        <a href={site.mailto} className={buttonStyles.outline} data-id="element-334" data-mp="3mvw19l999cqo">
          <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-335" data-mp="3ruh2no08u2gp" />
          {t({
          en: 'Email Us',
          es: 'Escríbenos'
        })}
        </a>
      </div>

      <dl className="mt-10 divide-y divide-mist border-y border-mist" data-id="element-336" data-mp="3du6ckn6rcrwl">
        <div className="flex gap-4 py-4" data-id="element-337" data-mp="3ivlu459q8ga8">
          <dt className="shrink-0" data-id="element-338" data-mp="3is7tp2kmih5f">
            <Clock3Icon className="h-6 w-6 text-sage-dark" aria-hidden="true" data-id="element-339" data-mp="33xtmdzaf8w6l" />
            <span className="sr-only" data-id="element-340" data-mp="38w4sq01icok2">{t({
              en: 'Hours',
              es: 'Horario'
            })}</span>
          </dt>
          <dd data-id="element-341" data-mp="125x7qgsyj67l">
            <p className="font-semibold text-ink" data-id="element-342" data-mp="125f4h07vnrq6">{t({
              en: 'Open 24 Hours',
              es: 'Abierto 24 Horas'
            })}</p>
            <p className="text-ink-soft" data-id="element-343" data-mp="175jimjlbcad8">{t({
              en: 'Nights, weekends, and holidays included',
              es: 'Noches, fines de semana y días festivos'
            })}</p>
          </dd>
        </div>
        <div className="flex gap-4 py-4" data-id="element-344" data-mp="10orik8zhntb7">
          <dt className="shrink-0" data-id="element-345" data-mp="10nq55xv02uqb">
            <MailIcon className="h-6 w-6 text-sage-dark" aria-hidden="true" data-id="element-346" data-mp="10qul1shtvewt" />
            <span className="sr-only" data-id="element-347" data-mp="vq6sh2dyaq0h">Email</span>
          </dt>
          <dd data-id="element-348" data-mp="rolcv9a17xml">
            <a href={site.mailto} className={`break-all rounded font-semibold text-ink hover:text-brand hover:underline ${focusRing}`} data-id="element-349" data-mp="rp4roh4dy5we">
              {site.email}
            </a>
          </dd>
        </div>
        <div className="flex gap-4 py-4" data-id="element-350" data-mp="1jgkcq6qankki">
          <dt className="shrink-0" data-id="element-351" data-mp="1jhlq4hus8j5e">
            <MapPinIcon className="h-6 w-6 text-sage-dark" aria-hidden="true" data-id="element-352" data-mp="1enr6fef6g46b" />
            <span className="sr-only" data-id="element-353" data-mp="1an78w9qoyyjn">{t({
              en: 'Address',
              es: 'Dirección'
            })}</span>
          </dt>
          <dd data-id="element-354" data-mp="274lhd4kcqgun">
            <address className="not-italic" data-id="element-355" data-mp="2753juixlxrb0">
              <a href={site.mapsUrl} target="_blank" rel="noopener noreferrer" className={`rounded font-semibold text-ink hover:text-brand hover:underline ${focusRing}`} data-id="element-356" data-mp="2764zz1thd3zl">
                {site.address.street}, {site.address.city}, {site.address.region} {site.address.postalCode}
              </a>
            </address>
            <p className="text-sm text-ink-soft" data-id="element-357" data-mp="3u08grznak4b0">{t({
              en: 'Open in Google Maps',
              es: 'Abrir en Google Maps'
            })}</p>
          </dd>
        </div>
      </dl>
    </div>;
}